import React from "react";
import { AddressFlyOut } from "../addressFlyOut";
export var EditAddressFlyOut = function (_a) {
    var open = _a.open, onOpenChange = _a.onOpenChange, onSubmit = _a.onSubmit, defaultValues = _a.defaultValues, isSubmitting = _a.isSubmitting;
    return (React.createElement(AddressFlyOut, { open: open, onOpenChange: onOpenChange, onSubmit: onSubmit, defaultValues: defaultValues, title: "Edit address", description: "Update your saved address details.", submitLabel: "Save changes", isSubmitting: isSubmitting }));
};
